module.exports = __webpack_public_path__ + "img/loading.25b9d7d8.gif";